// @flow
// All permissions are disabled by default
const hasPermission = (name: string, permissions: string[]): boolean => {
  let isAllowed = false;
  if (permissions) {
    isAllowed = permissions.find((permissionName) => name === permissionName) !== undefined;
  }
  return isAllowed;
};

const createPrintProductFromTemplatePermission = 'createPrintProductFromTemplate';
const createPrintProductByFullUploadPermission = 'createPrintProductByFullUpload';
const editPrintProductPermission = 'editPrintProduct';
const accessAdminDashboardPermission = 'accessAdminDashboard';
const accessApprovalsPermission = 'accessApprovals';
const accessOrderHistoryPermission = 'accessOrderHistory';
const manageUserPermission = 'manageUser';
const bulkEditProductsPermission = 'bulkEditProducts';
const orderAccessoriesPermission = 'orderAccessories';
const manageConsentPermission = 'manageConsent';

const permissionCheckerFor = (permission: string) => (permissions: string[]): boolean =>
  hasPermission(permission, permissions);

const canCreateProductFromTemplate = permissionCheckerFor(createPrintProductFromTemplatePermission);
const canUpdateProduct = permissionCheckerFor(editPrintProductPermission);
const canCreateProductByFullUpload = permissionCheckerFor(createPrintProductByFullUploadPermission);
const canAccessDashboard = permissionCheckerFor(accessAdminDashboardPermission);
const canAccessApprovals = permissionCheckerFor(accessApprovalsPermission);
const canAccessOrderHistory = permissionCheckerFor(accessOrderHistoryPermission);
const canManageUser = permissionCheckerFor(manageUserPermission);
const canBulkEditProducts = permissionCheckerFor(bulkEditProductsPermission);
const canOrderAccessories = permissionCheckerFor(orderAccessoriesPermission);
const canManageConsent = permissionCheckerFor(manageConsentPermission);

export {
  // Permissions
  createPrintProductFromTemplatePermission,
  editPrintProductPermission,
  createPrintProductByFullUploadPermission,
  accessAdminDashboardPermission,
  accessOrderHistoryPermission,
  manageUserPermission,
  bulkEditProductsPermission,
  orderAccessoriesPermission,
  manageConsentPermission,
  accessApprovalsPermission,
  // Functions
  canCreateProductFromTemplate,
  canUpdateProduct,
  canCreateProductByFullUpload,
  canAccessDashboard,
  canAccessApprovals,
  canAccessOrderHistory,
  canManageUser,
  canBulkEditProducts,
  canOrderAccessories,
  canManageConsent,
};
